import type { ReactNode } from "react";
import { BluebirdLayout } from "@/components/bluebird/BluebirdLayout";
import { SlimFooter, SubHero, SubMasthead } from "@/components/bluebird/Chrome";
import { Button, Wrap } from "@/components/bluebird/primitives";
import { space } from "@/lib/design-tokens";

function GuidesRetired() {
  return <>
    <SubMasthead current=""><SubHero line1="These guides have retired" line2="Let’s talk bikes instead" intro="Our old articles are no longer available. Browse the current bikes or bring your questions to the shop." /></SubMasthead>
    <main><Wrap padY={space.sectionY}><Button href="/bikes" variant="red">Browse the bikes</Button></Wrap></main>
    <SlimFooter />
  </>;
}
GuidesRetired.layout = (page: ReactNode) => <BluebirdLayout>{page}</BluebirdLayout>;
export default GuidesRetired;
